import { render, staticRenderFns } from "./AssetApprovalDetails.vue?vue&type=template&id=681ce09e&scoped=true"
import script from "./AssetApprovalDetails.vue?vue&type=script&lang=js"
export * from "./AssetApprovalDetails.vue?vue&type=script&lang=js"
import style0 from "./AssetApprovalDetails.vue?vue&type=style&index=0&id=681ce09e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681ce09e",
  null
  
)

export default component.exports